import { ForumPlusIcon } from './ForumPlusIcon';

/**
 * author: nlsve
 * id 148303DA-1AF8-48FF-82C4-A4B91108B231
 * name forum-plus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-plus.svg
 * tags
 */
export const ConversationPlusIcon = ForumPlusIcon;
export default ConversationPlusIcon